import React, { useState, useEffect } from "react";
import { Formik, FieldArray } from "formik";
import { ProductService } from "../../../services/product-service";
import { useParams } from "react-router-dom";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import Select from "react-select";


export const GroupProducts = (props) => {
  const { productID } = useParams();
  var bodyFormData = new FormData();
  let newProducts = props.groupProductsinfo;
  const mainStock = props.stock;
  const [submitloading, setSubmitLoading] = useState(true);
  const [ groupProducts, setGroupProducts] = useState([]);
  const [products, setProducts] = useState([]);

  const [ productId, setProductId ] = useState(0);
  const [ quantity, setQuantity ] = useState(0);
  const [ isButtonValid, setIsButtonValid] = useState(false);

  //add product data into group product

  const loadProduct = async (newProducts) =>{
    try{
      const groupProductsData = newProducts

      let finalArray = [];
      finalArray = await Promise.all(groupProductsData.map(async (product) => {
        if(product?.product != null){
          const result = await ProductService.productDetailsID(product.product_id);
          product["product_name"] = result.name;
          return product;
        }
      }))

      const cleanedArray = finalArray.filter(item => item != undefined);
      setGroupProducts(cleanedArray);
    }catch (err) {
      //toast
      console.error(err);
    }
  }



  const productDetailsSearch = async () => {
    try {
      const result = await ProductService.groupProductDetailsSearch();

      setProducts(result.results);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const viewMainProduct = async () => {
    try {

      const result = await ProductService.productDetailsID(productId);
      console.error('--------result---------',result);
      console.error('--------quantity---------',quantity);
      if(result.stock > 1){
        const totalQuantity = 1;

        // if(result.stock < totalQuantity){
          setIsButtonValid(true);
          notifyWarning(result.name +' has only ' + result.stock + ' products in stock')
        // }else{
        //   setIsButtonValid(false);
        // }
      }else{
        setIsButtonValid(true);
        notifyWarning(result.name +' has only ' + result.stock + ' products in stock')
      }

    } catch (err) {
      //toast
      console.error(err);
    }
  };

  useEffect(()=> {
    productDetailsSearch()
  },[])

  useEffect(() => {
    loadProduct(newProducts);
  },[newProducts])

  useEffect(() => {
    viewMainProduct(quantity);
  },[quantity])

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);


    try {
      await ProductService.groupProductUpdate(productID, values.groupProducts);

      setSubmitLoading(true);
      notify("Group Product successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
      //show error toast
    }
  };

  let ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
  }));


  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Group Product List</h6>
            </div>
            <div className="ms-panel-body">
              <div className="row">
                <div className="col-sm-12">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      groupProducts: groupProducts,

                    }}
                    onSubmit={onSubmitForm}
                    render={({
                      errors,
                      handleBlur,
                      handleChange,
                      touched,
                      values,
                      submitForm,
                      isValid,
                      setFieldValue,
                    }) => (
                      <div>
                        <div className="col-md-12 mb-6">
                          <FieldArray
                            name="groupProducts"
                            render={(arrayHelpers) => (
                              <div>
                                {values.groupProducts.map((gProduct, index) => (
                                  <div key={index}>
                                    <div className="form-row">
                                      <div className="col-md-6 mb-3">
                                      <label htmlFor="validationCustom25">Product Name</label>
                                          <Select
                                            options={ProductOptions}
                                            onChange={(selectedOption)=>{
                                              setFieldValue(`groupProducts[${index}].product_id`, selectedOption ? selectedOption.value : "")
                                            }}
                                            isClearable
                                            placeholder="Select Product"
                                            isDisabled={gProduct.product_id ? true : false}
                                            // value={ProductOptions.find(option => option.value === values.groupProducts[index].product_id)}
                                            value={ProductOptions.find(option => option.value === (values.groupProducts[index].product_id != "" ? values.groupProducts[index].product_id : gProduct.product_id))}
                                          />
                                        {/* <div className="input-group">
                                          <select
                                            onChange={(e) => {
                                              setFieldValue(`groupProducts[${index}].product_id`, e.target.value)
                                            }}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            id="validationCustom25"
                                            placeholder="Product"
                                            name={`groupProducts[${index}].product_id`}
                                            value={gProduct.product_id ? gProduct.product_id : ""}
                                            disabled={gProduct.product_id ? true : false}
                                          >
                                            <option value="">Select Product</option>
                                            {products.map((product) => {
                                              return (
                                                <option key={product.id} value={product.id}>{product.name}</option>
                                              )
                                              
                                            })}
                                          </select>
                                        </div> */}
                                      </div>
                                      {/* <div className="col-md-3 mb-3">
                                      <label htmlFor="validationCustom25">Quantity</label>
                                        <div className="input-group">
                                          <input
                                            onChange={(e) => {
                                              setFieldValue(`groupProducts[${index}].quantity`, e.target.value)
                                              setProductId(gProduct.product_id)
                                              setQuantity(e.target.value)

                                            }}
                                            onBlur={handleBlur}
                                            type="number"
                                            className="form-control"
                                            id="validationCustom26"
                                            placeholder=""
                                            required
                                            name={`groupProducts[${index}].quantity`}
                                            value={gProduct.quantity ? gProduct.quantity : quantity}
                                            
                                          />
                                        </div>
                                      </div> */}
                                      <div className="col-md-3 mb-3">
                                      <label htmlFor="validationCustom25">Remove</label>
                                        <div>
                                          <button
                                            type="button"
                                            className="ms-btn-icon btn-primary"
                                            name="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                            style={{
                                              marginBottom: "2vh",
                                              backgroundColor: "red",
                                            }}
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                <button
                                    type="button"
                                    className="ms-btn-icon btn-primary"
                                    name="button"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        product_id: "",
                                        // quantity: "",
                                      })
                                    }
                                    style={{ marginBottom: "1vh" }}
                                  >
                                    +
                                  </button>
                              </div>
                            )}
                          />
                          <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.groupProducts}
                            </div>
                        </div>
                        <div className="col-md-2" hidden={submitloading}>
                          <div className="spinner spinner-7">
                            <div className="bounce1" />
                            <div className="bounce2" />
                            <div className="bounce3" />
                          </div>
                        </div>

                        <button
                          type="button"
                          className="btn btn-primary shadow-none float-right"
                          onClick={submitForm}
                          disabled={isButtonValid}
                        >
                          Save and Update
                        </button>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupProducts;
